(function() {
'use strict';
angular.module('cms')
    .config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/cms/preview/:pageId/:componentId', {
            template: '<div ng-include="cc.template"><h1>Loading...</h1></div>',
            controllerAs: 'cc',
            controller: ['$routeParams', function($routeParams) {
                this.template = `cms/component/${$routeParams.pageId}/${$routeParams.componentId}?device=Apps`;
            }]
        });
    }]);
})();
